// import { permissionsConstant } from "@/helpers/permissionsConstant";

export default [
  {
    path: "/super-admin-login",
    name: "super-admin-login",
    component: () => import("@/views/super-admin/auth/LoginView.vue"),
    meta: {
      pageTitle: "Super Admin Login",
      requiresAuth: false,
      requiresVisitor: true,
      layout: "full",
    },
  },
  {
    path: "/super-admin/forgot-password",
    name: "super-admin-forgot-password",
    component: () => import("@/views/super-admin/auth/ForgotPasswordView.vue"),
    meta: {
      pageTitle: "Forgot Password",
      requiresAuth: false,
      requiresVisitor: true,
      layout: "full",
    },
  },
  {
    path: "/super-admin/reset-password",
    name: "super-admin-reset-password",
    component: () => import("@/views/super-admin/auth/ResetPasswordView.vue"),
    meta: {
      pageTitle: "Reset Password",
      requiresAuth: false,
      requiresVisitor: true,
      layout: "full",
    },
  },
];
